import { ComponentProps } from "react";
import { VideoEmbed } from "../VideoEmbed";

const VideoEmbedSerializer = (props: ComponentProps<typeof VideoEmbed>) => (
  <VideoEmbed borderRadius={{ base: "none", md: "xl" }} {...props} />
);

export default VideoEmbedSerializer;
